const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/rail2020/admin',
      name: 'proc_rail2020_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/rail2020/appl',
      name: 'proc_rail2020_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/rail2020/router.js